import { render, staticRenderFns } from "./VuetablePaginationBootstrap.vue?vue&type=template&id=1a7b4eda&"
import script from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports